import { FormSection } from '@ksyos/design-system';
import { useEffect } from 'react';
import type { RespiAllerResendQuestionnaireData } from '@common/validation/customControls/allergology/respiAllerResendQuestionnaireSchema';
import { useProcessActivityEditContext } from '@frontend/utils';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';
import { EmailAddressFormGroup } from '../../EmailAddressFormGroup';

export function RespiAllerResendQuestionnaireEdit() {
    const { data, errors, onChange } = useProcessActivityEditContext<RespiAllerResendQuestionnaireData>();

    const { patient } = usePatientEpisodeCategoryContext();

    useEffect(() => {
        onChange(
            {
                patient: {
                    emailAddress: patient?.emailAddress ?? null,
                },
            },
            ['patient.emailAddress']
        );
    }, [patient]);

    return (
        <FormSection>
            <EmailAddressFormGroup<RespiAllerResendQuestionnaireData>
                data={data}
                errors={errors}
                onChange={onChange}
            />
        </FormSection>
    );
}
